import React from 'react';
import Input from '../../forms/Input';
import { PATH } from '../util/paths';
import i18n from '../../../common/i18n';

const SmsInput = ({ form, setInput }) => {
    return (
        <Input
            form={form}
            path={PATH.SMS_CODE}
            label={i18n('nui.two.fa.label.sms')}
            autocomplete="sms"
            type="text"
            autocapitalize="off"
            onInput={e => setInput(e.target.value)}
            dataAtid="text-form-input-sms"
        />
    );
};

export default SmsInput;
